// 信用卡付款模組
export function setup() {
  const fields = {
    number: {
      element: "#card-number",
      placeholder: "**** **** **** ****"
    },
    expirationDate: {
      element: "#card-expiration-date",
      placeholder: "MM / YY"
    },
    ccv: {
      element: "#card-ccv",
      placeholder: "安全碼"
    }
  }

  TPDirect.card.setup({
    fields: fields,
    styles: {
      input: { color: "gray" }
    }
  })
}

export function onUpdate(callback) {
  TPDirect.card.onUpdate(callback)
}

export function getPrime() {
  return new Promise((resolve, reject) => {
    TPDirect.card.getPrime((result) => {
      if (result.status !== 0) {
        reject(new Error(result.msg))
      } else {
        resolve(result.card.prime)
      }
    })
  })
}
